import React from 'react'
import { NavigationContainer } from '@react-navigation/native'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import NewWorkOrderScreen from '@screens/WorkOrders/new/NewWorkOrderScreen'
import WorkOrdersScreen from '@screens/WorkOrders/list/WorkOrdersScreen'
import ProfileEditScreen from '@screens/Profile/ProfileEditScreen'

const Tab = createBottomTabNavigator()

export default function () {
  return (
    <NavigationContainer>
      <Tab.Navigator
        initialRouteName="newWorkOrder"
        screenOptions={{
          headerShown: false,
        }}
      >
        <Tab.Screen name="newWorkOrder" component={ NewWorkOrderScreen } />
        <Tab.Screen name="profile" component={ ProfileEditScreen } />
        <Tab.Screen name="workOrders" component={ WorkOrdersScreen } />
      </Tab.Navigator>
    </NavigationContainer>
  )
}
